import { render, staticRenderFns } from "./capacityList.vue?vue&type=template&id=47ffe1b5"
import script from "./capacityList.vue?vue&type=script&lang=js"
export * from "./capacityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports